import React, { useEffect, useState } from 'react';
import { Button, Box, Typography, Container, Link, Divider } from '@mui/material';
import '../../style/signIn.css';
import '../../style/common.css';
import BrandLogo from '../../assets/brand-logo.jpg';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import * as signInActions from '../../store/actions/auth';
import { connect } from 'react-redux';
import SpinningLoader from '../../components/SpinningLoader'
import { useMsal } from "@azure/msal-react";

//Azure
import { loginRequest } from "../../config/msalConfig";
import { setCookie, getCookie } from '../../components/Helper/cookies';
import * as userActions from '../../store/actions/userManagement'


const SignIn = ({ azureLogOut, getProfileDetails, userProfile }) => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [userStatus, setUserStatus] = useState({ isLoginError: false, isUserResetPassword: false });
  const auth = JSON.parse(window.sessionStorage.getItem('userInfo')) || JSON.parse(window.localStorage.getItem('userInfo'))
  if(auth) {
    navigate('/home')
  }
  const clearCookies = () => {
    setCookie("isLoginFailed", "");
    setCookie("isUserResetPassword", "");
    setUserStatus({ isLoginError: false, isUserSignUp: false, isUserResetPassword: false })
  }
  const handleMailToClick = () => {
    window.open('mailto:mplb@martinrea.com', '_blank');
  };
  
  useEffect(() => {
    if (getCookie("isLoginFailed") === "true") {
      setUserStatus({ ...userStatus, isLoginError: true })
      const swalWithCustompButtons = Swal.mixin({
        customClass: {
          confirmButton: 'custom-ok-button',
        },
        buttonsStyling: false
      })
      swalWithCustompButtons.fire({
        title: "",
        text: 'Authentication (login or password) has failed. Please try again',
        showCancelButton: false,
        confirmButtonText: 'Ok',
      }).then((result) => {
        if (result.isConfirmed) {
          clearCookies();
        }
      })
    }
    if (getCookie("isUserResetPassword") === "true") {
      setUserStatus({ ...userStatus, isUserResetPassword: true })
    }

    if (window.sessionStorage.getItem("isLogout") === "true") {
      sessionStorage.clear();
      localStorage.clear();
    }
   

    instance.addEventCallback(async (event) => {
      if (event.eventType === "msal:loginSuccess"|| event.eventType === "msal:acquireTokenSuccess") {
        if (event?.payload?.idTokenClaims?.isForgotPassword) {
          setCookie("isUserResetPassword", true);
          azureLogOut(instance);
        }
        const myAccount = instance.getAccountByHomeId(event.payload.account?.homeAccountId);
        instance.setActiveAccount(myAccount);
        window.sessionStorage.setItem("home_account", JSON.stringify(myAccount));
        window.localStorage.setItem("home_account", JSON.stringify(myAccount));
        window.sessionStorage.setItem("user_name", event.payload.account.idTokenClaims.preferred_username);
        window.sessionStorage.setItem("userFullName", event.payload.account.idTokenClaims.name);
        window.localStorage.setItem("userFullName", event.payload.account.idTokenClaims.name);
        window.localStorage.setItem("user_name", event.payload.account.idTokenClaims.preferred_username);
        window.sessionStorage.setItem("tokenDetail", event.payload.idToken);
        window.localStorage.setItem("tokenDetail", event.payload.idToken);
        const oauth = {
          token_type: "Bearer",
          access_token: event.payload.idToken
        }
        window.sessionStorage.setItem("oauthToken", JSON.stringify(oauth));
        window.localStorage.setItem("oauthToken", JSON.stringify(oauth));
        const payload = {
          token: event.payload.idToken,
          email: event.payload.account.username,
          userName : event.payload.account.idTokenClaims.name
        }
         getProfileDetails(payload, instance);
      }
      if (event.eventType === "msal:loginFailure" || event.eventType === "msal:acquireTokenFailure") {
        azureLogOut(instance);
      }

    }, error => {
      console.log('error', error);
    });

  }, [])

  const handleAzureLogin = (msalIns) => {
    clearCookies();
    msalIns.loginRedirect(loginRequest).then().catch(e => {
      console.error(e);
    });
  }
  useEffect(() => {
      if (userProfile && userProfile?.status === 200)  {
        window.location.href = "/home"
      }
    }, [userProfile])
    if (userProfile?.isLoading) {
      return <SpinningLoader circleColor="#005974" />;
    } 
  
  return (
    <Container component="main" maxWidth="xs" className="login-conatiner">
      <Box
        sx={{  
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        className="login-card"
      >
          <Typography component="h1" variant="h5" className="mb-30 mt-30">
            <b>Login to your account</b>
          </Typography>
          <img src={BrandLogo} width={240} height={121} style={{objectFit: 'contain'}}/>
          <Button
            type="submit"
            fullWidth
            onClick={() => { handleAzureLogin(instance) }}
            variant="contained"
            className="primary-btn login-curve mt-30"
          >
            <b>Login</b>         
        </Button>
        <Divider className='divider-login mt-30 mb-30'>or</Divider>
        <Typography className='xs-normal' style={{textAlign: 'center'}}>Please contact the Making People’s Lives Better <br></br>
          helpdesk at <b style={{color: '#01A3E4'}}>mplb@martinrea.com</b>
          <br></br> if you have any trouble in accessing the platform.</Typography>
        <Button 
          onClick={handleMailToClick} 
          className='mb-20 contact-btn mt-20'
          variant="outlined"
        >
          Contact Us
        </Button>
      </Box>
    </Container>
  );
}
const mapStateToProps = (state) => ({ 
  userProfile: state.userReducer.userProfile,
 })

const mapDispatchToProps = (dispatch) => {
  return {
    azureLogOut: (instance) => dispatch(signInActions.azureLogOut(instance)),
    getProfileDetails: (email, instance) => dispatch(userActions.getProfileDetails(email, instance)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);


SignIn.propTypes = {
  azureLogOut: PropTypes.func.isRequired,
}

